var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Infinite from "react-infinite";
import { withContentRect } from "react-measure";
import selectn from "selectn";

import Spinner from "../../Library/Spinner";
import StoryCard from "../../Library/StoryCard";
import SummaryCard from "../../Library/SummaryCard";
import EventCard from "../../Library/EventCard";
import StreamAd from "../../Library/StreamAd";

import styles from "./StoriesStream.css";

var contentRectHoc = typeof window === "undefined" ? function () {
  return function (callback) {
    return callback;
  };
} : withContentRect;
var MeasuredStory = contentRectHoc("client")(function (_ref) {
  var measureRef = _ref.measureRef,
      Wrapper = _ref.Wrapper,
      story = _ref.story,
      storyClassName = _ref.storyClassName,
      showDivider = _ref.showDivider,
      index = _ref.index,
      isLastStory = _ref.isLastStory,
      adId = _ref.adId,
      stream = _ref.stream,
      permalinkId = _ref.permalinkId;
  return React.createElement(
    "div",
    { ref: measureRef, role: "article", tabIndex: "-1" },
    showDivider === "start" && React.createElement("hr", { className: classNames("mx-4", styles.separator), "aria-hidden": true }),
    story.isAd ? React.createElement(StreamAd, { advert: story, adId: adId, stream: stream }) : React.createElement(Wrapper, { story: story, isLastStory: isLastStory, permalinkId: permalinkId, index: index, className: classNames(index !== 0 ? "my-3" : "mb-3", storyClassName) }),
    showDivider === "end" && React.createElement("hr", { className: classNames("mx-4", styles.separator), "aria-hidden": true })
  );
});

var StoriesStream = function (_Component) {
  _inherits(StoriesStream, _Component);

  function StoriesStream(props) {
    _classCallCheck(this, StoriesStream);

    var _this = _possibleConstructorReturn(this, (StoriesStream.__proto__ || Object.getPrototypeOf(StoriesStream)).call(this, props));

    _this.getStream = function (stream) {
      if (!stream) return "misc";
      if (stream === "top") return "homepage";
      return "section-" + stream;
    };

    _this.getStoriesAndAds = function (stories) {
      if (!_this.props.showAds) return stories.results;

      var results = [].concat(_toConsumableArray(stories.results));
      var placedAds = 0;
      var startAd = 2;
      var gap = 4;

      // If there is an adId prop passed in, put an ad first in the response.
      if (_this.props.adId) {
        results.splice(0, 0, _this.getAd(1, undefined, undefined));
        return results;
      }

      // First ad after 1st post for top
      if (_this.props.stream === "top" && stories.results.length >= 2) {
        results.splice(1, 0, _this.getAd(1, results[0], results[1]));
        startAd = 7;
      }

      if (results.length < startAd) return results;

      var insertIndex = startAd + placedAds + placedAds * gap;

      // Ads every 4 posts starting after 6th for top and 2nd for other streams
      while (insertIndex <= results.length) {
        results.splice(insertIndex, 0, _this.getAd(placedAds + 2, results[insertIndex - 1], results[insertIndex]));
        placedAds += 1;
        insertIndex = startAd + placedAds + placedAds * gap;
      }

      return results;
    };

    _this.getAd = function (index, beforePost, afterPost) {
      var postIds = [selectn("id", beforePost), selectn("id", afterPost)];
      var beforeTags = beforePost ? (beforePost.tags || []).map(function (t) {
        return t.name;
      }).concat(selectn("primary_tag.name", beforePost)) : [];
      var afterTags = afterPost ? (afterPost.tags || []).map(function (t) {
        return t.name;
      }).concat(selectn("primary_tag.name", afterPost)) : [];

      return {
        id: "ad_" + index,
        isAd: true,
        index: index,
        postIds: postIds,
        beforeTags: beforeTags,
        afterTags: afterTags
      };
    };

    _this.defaultCardHeight = _this.props.isSummary || _this.props.isEvent ? 200 : 500;

    _this._handleInfiniteLoad = _this._handleInfiniteLoad.bind(_this);

    _this.state = {
      loading: false,
      page: 1,
      //prevent auto loading of second page on pages where results aren't rendered yet
      //TODO remove > 1 - this is a hack until permalinks render correctly on server: https://jira.axios.com/browse/SITE-387
      attemptInfiniteLoad: props.stories.results && props.stories.results.length > 1 ? true : undefined,
      elementHeights: {}
    };
    return _this;
  }

  _createClass(StoriesStream, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.stories.isFinished) {
        this.setElementHeights(this.props.stories);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextStories = nextProps.stories;
      var currentStories = this.props.stories;
      if (nextStories.isFinished && nextStories.results && nextStories.results !== currentStories.results) {
        this.setElementHeights(nextStories);
        this.setState({ attemptInfiniteLoad: true });
      }
      if (!currentStories.isError && nextStories.isError) {
        this.setState({ attemptInfiniteLoad: undefined, loading: false });
      }
      if (!nextStories.results || nextStories.isLoading) {
        this.setState({ page: 1 });
      }
    }
  }, {
    key: "setElementHeights",
    value: function setElementHeights(stories) {
      var _this2 = this;

      var results = this.getStoriesAndAds(stories);
      // Because children haven't been measured yet, set height initially to an approximate value: 500px
      var elemHeights = results.reduce(function (accum, story) {
        return _extends({}, accum, _defineProperty({}, story.id, selectn("elementHeights." + story.id, _this2.state) || _this2.defaultCardHeight));
      }, {});
      this.setState({
        // Keep heights that have already been calculated
        elementHeights: elemHeights
      });
    }
  }, {
    key: "_updateSize",
    value: function _updateSize(id, height) {
      if (this.state.elementHeights[id] !== height) {
        this.setState({
          elementHeights: _extends({}, this.state.elementHeights, _defineProperty({}, id, height))
        });
      }
    }
  }, {
    key: "_handleInfiniteLoad",
    value: function _handleInfiniteLoad() {
      var _this3 = this;

      var page = this.state.page + 1;
      this.setState({ loading: true, page: page });
      this.props.next(page).then(function () {
        return _this3.setState({ loading: false });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          stories = _props.stories,
          storyClassName = _props.storyClassName,
          isSummary = _props.isSummary,
          isEvent = _props.isEvent,
          showUnread = _props.showUnread;

      if (!stories.results || stories.isLoading) return React.createElement(
        "div",
        { className: styles.spinnerWrapper },
        React.createElement(Spinner, null)
      );

      var Wrapper = isSummary ? SummaryCard : isEvent ? EventCard : StoryCard;

      var storyStreamWithAds = this.getStoriesAndAds(stories);
      // We cannot guarantee the uniqueness of IDs in elementHeights so we need
      // to map them back against storyStreamWithAds to return an array of element heights.
      // When ads don't render assign height of 0 or infinite scroll breaks
      var elementHeights = storyStreamWithAds.map(function (story) {
        return _this4.state.elementHeights[story.id] || (story.isAd ? 0 : _this4.defaultCardHeight);
      });
      var onServer = typeof window === "undefined";
      var containerProps = onServer ? { containerHeight: 2000 } : { useWindowAsScrollContainer: true };

      return React.createElement(
        Infinite,
        _extends({}, containerProps, {
          className: styles.infinite,
          elementHeight: elementHeights,
          infiniteLoadBeginEdgeOffset: this.state.attemptInfiniteLoad && this.defaultCardHeight,
          preloadBatchSize: Infinite.containerHeightScaleFactor(2),
          preloadAdditionalHeight: Infinite.containerHeightScaleFactor(30),
          loadingSpinnerDelegate: React.createElement(Spinner, null),
          onInfiniteLoad: this._handleInfiniteLoad,
          isInfiniteLoading: this.state.loading
        }),
        storyStreamWithAds.map(function (story, index) {
          var showDivider = _this4.props.lastSeenId === story.id && index !== 0 ? "start" : !_this4.props.lastSeenId && index === stories.results.length - 1 ? "end" : false;
          return React.createElement(MeasuredStory, {
            key: story.id,
            index: index,
            adId: _this4.props.adId,
            stream: _this4.getStream(_this4.props.stream),
            isLastStory: stories.results.length - 1 === index,
            story: story,
            showDivider: showUnread && showDivider,
            Wrapper: Wrapper,
            storyClassName: storyClassName,
            onResize: function onResize(contentRect) {
              _this4._updateSize(story.id, contentRect.client.height);
            },
            permalinkId: _this4.props.permalinkId
          });
        })
      );
    }
  }]);

  return StoriesStream;
}(Component);

StoriesStream.propTypes = {
  next: PropTypes.func.isRequired,
  stories: PropTypes.object.isRequired,
  isSummary: PropTypes.bool,
  isEvent: PropTypes.bool,
  showUnread: PropTypes.bool,
  storyClassName: PropTypes.string
};

export default StoriesStream;


// WEBPACK FOOTER //
// ./src/components/Library/StoriesStream/StoriesStream.js